<template>
  <div class="room pk-battle-room" :style="{ '--backimg': backcssVars() }">
    <section v-if="roomUnavailable" class="pk-battle-room-unavailable">
      <strong>该对战房间暂不可用</strong>
      <span>房间可能已结束、被删除或暂时无法读取。</span>
      <button type="button" @click="goLucky">返回对战列表</button>
    </section>
    <div v-if="!roomUnavailable" class="room-right">
      <div class="room-right-name">
        <span
          >{{
            fightboxList[boxListIndex] ? fightboxList[boxListIndex].name : ""
          }} </span
        >包含以下奖励
      </div>
      <div class="room-right-list">
        <div class="roomlist-title">详情</div>
        <div class="roomlist">
          <ul>
            <li v-for="(item, index) in boxList[boxListIndex]" :key="index">
              <div class="roomlist-warp">
                <div class="roomlist-img">
                  <img :src="item.imageUrl" @error="useSkinFallback($event, index)" />
                </div>
                <div class="roomlist-name" :title="item.itemName">
                  {{ item.itemName }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!roomUnavailable" class="room-left">
      <div class="room-left-hint">
        <div class="roomleft-num">
          <span @click="goLucky">盲盒对战</span>
          <span>></span>
          <span>参加对战编号 {{ id }}</span>
        </div>
        <div class="roomleft-btn">
          <span @click="goLuckyRule">对战规则</span>
          <span @click="goLuckyHistory">对战历史</span>
          <!-- <span>邀请好友</span> -->
        </div>
      </div>
      <div class="room-left-box">
        <div class="roombox-warp">
          <ul>
            <li
              v-for="(item, index) in fightboxList"
              :key="index"
              :id="item.state ? 'room-li' : ''"
            >
              <div class="roombox-num">
                <div class="roombox-img" @click="selImg(index)">
                  <img :src="item.img_main" @error="useCaseFallback($event, index)" />
                </div>
                <div class=""></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="room-left-people">
        <div class="roompe-warp">
          <div class="roompe-line" v-if="roomLineState"></div>
          <ul class="ul1">
            <li
              class="li1"
              v-for="(item, index) in peopleList"
              :key="index"
              :style="{ width: item.width }"
            >
              <div
                class="room-warp"
                :class="[
                  item.winState ? 'room-win-status' : 'room-fail-status',
                  canTargetProp(item) ? 'battle-prop-target' : '',
                ]"
                @click="sendBattleProp(item)"
              >
                <div
                  v-for="event in battlePropEventsFor(item.id)"
                  :key="event.id"
                  class="battle-prop-impact"
                >
                  <img v-if="event.image_url" :src="event.image_url" :alt="event.prop_name" />
                  <b v-else>{{ event.prop_name.slice(0, 1) }}</b>
                  <span>{{ event.prop_name }}</span>
                </div>
                <div class="room1">
                  <div class="room1-img" v-if="item.end == 2">
                    <div
                      :class="
                        item.winState
                          ? 'room1-text1 room1-win'
                          : 'room1-text2 room-back'
                      "
                    >
                      <img
                        class="win-img"
                        src="../assets/img/lucky/win.png"
                        alt=""
                        v-if="item.winState"
                        srcset=""
                      />
                      <img
                        v-else
                        class="fail-img"
                        src="../assets/img/lucky/fail.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                  </div>
                  <div class="room1-img" v-if="item.state && item.end == 1">
                    <img src="../assets/img/gou.png" />
                  </div>
                  <div class="room1-img" v-if="!item.state">
                    <el-button
                      v-if="!item.state"
                      @click="goParticipate(index)"
                      :disabled="disabled"
                      ><i v-if="loading" class="el-icon-loading"></i>
                      加入对战
                    </el-button>
                  </div>

                  <div class="pool" v-if="openWin">
                    <ul
                      :class="{
                        'pool-ul2': mode == 2,
                        'pool-ul3': mode == 3,
                        'pool-ul4': mode == 4,
                        'pool-ul5': mode == 5,
                        'pool-ul6': mode == 6,
                      }"
                    >
                      <li
                        v-for="(itemBox, indexBox) in item.fightBox"
                        :key="indexBox"
                      >
                        <div class="pool-img">
                          <img :src="itemBox.imageUrl" @error="useSkinFallback($event, indexBox)" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="room2">
                  <div class="room2-tou" v-if="item.state">
                    <img :src="item.img" @error="useAvatarFallback" />
                  </div>
                  <div class="room2-name" v-if="item.state">
                    {{ item.name }}
                  </div>
                  <span v-if="!item.state">等待玩家</span>
                </div>
                <div class="win-list">
                  <div class="win-title">
                    <img src="../assets/img/money.png" />
                    <span>{{ item.totalPrice }}</span>
                  </div>
                  <ul class="win-ul">
                    <li
                      class="win-li"
                      v-for="(item1, index1) in item.box"
                      :key="index1"
                    >
                      <div class="win-warp">
                        <div class="img">
                          <img :src="item1.img" @error="useSkinFallback($event, index1)" />
                        </div>
                        <h6>
                          <img src="../assets/img/money.png" />
                          <span>{{ item1.price }}</span>
                        </h6>
                        <h6 :title="item1.name">{{ item1.name }}</h6>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <div class="room-line" v-if="lineState"></div>
          </ul>
        </div>
      </div>
      <div class="room-left-bot">
        <!-- <p>公平性验证</p>
        <p>参加活动编号 - 813227561387798528</p>
        <p>随机数 - 2968b3a4324279ba9f4f4e6d19ba2a92</p>
        <p>[关于公平性验证]</p> -->
      </div>
      <section v-if="battleProps.length" class="battle-prop-dock">
        <div class="battle-prop-heading">
          <span>互动道具</span>
          <em>选择当前道具</em>
        </div>
        <button
          v-for="item in battleProps"
          :key="item.prop_id"
          type="button"
          class="battle-prop-item"
          :class="{ active: selectedBattleProp && selectedBattleProp.prop_id == item.prop_id }"
          @click="selectBattleProp(item)"
        >
          <img v-if="item.image_url" :src="item.image_url" :alt="item.name" />
          <b v-else>{{ item.name.slice(0, 1) }}</b>
          <strong>{{ item.name }}</strong>
          <em>x{{ item.quantity }}</em>
        </button>
      </section>
    </div>

    <audio controls ref="notify1" class="audio" loop="loop">
      <source src="../assets/audio/open8.mp3" />
    </audio>
    <myhomebot v-if="!roomUnavailable"></myhomebot>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";

import Utils from "./../assets/js/util.js";
import { battle } from "@/api/socket.js";
export default {
  components: { myhomebot },
  data() {
    return {
      add: false,
      roomUnavailable: false,
      disabled: false,
      loading: false,
      roomLineState: false,
      roomStatus: "",
      roomRefreshTimer: null,
      id: "",
      winList: [
        {
          name: 1,
        },
        {
          name: 2,
        },
        {
          name: 3,
        },
      ],
      loser: [
        {
          name: "",
          img: "",
          price: "0.01",
        },
      ],
      boxList: [],
      boxListIndex: 0,
      fightboxList: [],
      fightImg: [],
      fightImgObj: [],
      peopleList: [],
      peopleObj: {
        name: "凉凉奖励",
        width: "",
        state: true,
        price: "0.01",
        img: require("../assets/img/moneyback.png"),
        loading: false,
      },
      img: "",
      lineState: false,
      openWin: false,
      mode: "",
      openBox: [
        {
          state: false,
        },
      ],
      battleProps: [],
      selectedBattleProp: null,
      battlePropEvents: [],
      propEventCursor: 0,
      propEventsInitialized: false,
      propEventTimer: null,
      sendingBattleProp: false,
      totalPrice: 0,
      adds: false,
      caseFallbackImages: [
        require("../assets/hotpizza/hp-case-purple-transparent.png"),
        require("../assets/hotpizza/hp-case-crystal.png"),
        require("../assets/hotpizza/hp-case-orange.png"),
        require("../assets/hotpizza/hp-case-green.png"),
        require("../assets/hotpizza/hp-case-blue.png"),
        require("../assets/hotpizza/hp-case-ice.png"),
      ],
      skinFallbackImages: [
        require("../assets/hotpizza/hp-mp9-red.png"),
        require("../assets/hotpizza/hp-m4-blue.png"),
        require("../assets/hotpizza/hp-awp-blue.png"),
        require("../assets/hotpizza/hp-ak-green.png"),
        require("../assets/hotpizza/hp-awp-fire.png"),
        require("../assets/hotpizza/hp-m4-cyan.png"),
      ],
    };
  },
  watch: {
    add(val) {
      if (val == false) {
        this.getRoomList1();
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getRoomList();
    this.roomRefreshTimer = setInterval(() => {
      if (String(this.roomStatus) === "1" && !this.add) {
        this.getRoomList();
      }
    }, 5000);
    this.getBack();
    if (this.$store.state.token || localStorage.getItem("token")) {
      this.getBattleProps();
    }
    this.getBattlePropEvents();
    this.propEventTimer = setInterval(() => {
      this.getBattlePropEvents();
    }, 3000);
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    //关闭
    //clearInterval(this.timer);
    if (this.websock && typeof this.websock.close === "function") {
      this.websock.close();
    }
    clearInterval(this.roomRefreshTimer);
    clearInterval(this.propEventTimer);
  },
  methods: {
    backcssVars() {
      return `url("${this.img}")`;
    },
    //音乐 播放
    playAlarm1() {
      this.$refs.notify1.play();
    },
    //音乐 结束
    playAlarm2() {
      this.$refs.notify1.pause();
    },
    //推送
    initWebSocket() {
      const wsuri = battle();
      if (!wsuri) {
        return;
      }
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {},

    websocketonerror() {
      // Local deployment uses HTTP polling until a PizzaKing gateway is configured.
    },

    //请求背景图片
    getBack() {
      let _this = this;
      _this.$axios.post("/index/Setting/background").then((res) => {
        if (res.data.status == 1) {
          this.img = res.data.data.img;
          if (!this.img) {
            this.img = this.img1;
          }
        }
      });
    },
    websocketonmessage(d) {
      let da = JSON.parse(d.data);
      if (da.info) {
        this.sockBattleList(da);
      }
    },

    websocketsend(Data) {
      if (this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(Data);
      }
    },

    websocketclose(e) {
      //console.log("close:", e);
    },

    sockBattleList(data) {
      console.log("推送数据->:", data.info);
      if (data.info) {
        if (data.info.id == this.id) {
          if (data.info.status != 3) {
            this.getRoomList();
          }
          if (data.info.status == 3) {
            // console.log("状态3")
            this.add = false;
          }
        }
      }
    },

    //跳转
    goLucky() {
      this.$router.push({
        path: `/Lucky`,
      });
    },
    //获取房间信息
    getRoomList(over, tt) {
      if (String(this.id).indexOf("preview-") == 0) {
        this.markRoomUnavailable();
        return;
      }
      if (this.add) {
        return;
      }
      this.boxList = [];
      this.fightImg = [];
      this.fightImgObj = [];
      this.totalPrice = 0;
      let param = {
        battle_id: this.id,
      };
      this.$axios
        .post("/index/Battle/battleDetail", this.$qs.stringify(param))
        .then((res) => {
          var JSONres = JSON.parse(JSON.stringify(res));
          var aaa = JSON.parse(JSON.stringify(res.data.data));
          var playerinfo = JSON.parse(
            JSON.stringify(res.data.data.player_info)
          );
          if (over) {
            var re = {
              state: "update",
              info: res.data.data,
            };
            Utils.$emit("update", JSON.stringify(re));
          }
          var data = res.data;
          console.log("房间信息", data);
          if (data.status == "1") {
            this.roomUnavailable = false;
            this.roomStatus = data.data.status;
            this.fightboxList = this.normalizeRoomBoxes(data.data.boxInfo);
            for (let i = 0; i < this.fightboxList.length; i++) {
              this.boxList.push(this.fightboxList[i].skin_list);
            }
            this.peopleList = this.normalizePlayers(data.data.player_info);
            var mode = data.data.mode;
            var peopleListCopy = JSON.parse(JSON.stringify(this.peopleList)); //深拷贝
            if (mode != peopleListCopy.length) {
              for (let i = 0; i < mode - peopleListCopy.length; i++) {
                this.peopleList.push(this.peopleObj);
              }
            }
            for (let i = 0; i < this.peopleList.length; i++) {
              if (this.peopleList[i].id) {
                this.peopleList[i].state = true;
              } else {
                this.peopleList[i].state = false;
              }
              //   if (mode == 2) {
              //     this.peopleList[i].width = "48%";
              //   } else if (mode == 3) {
              //     this.peopleList[i].width = "33.33%";
              //   } else {
              //     this.peopleList[i].width = "25%";
              //   }
            }

            //对战的滚动图片数据
            for (let i = 0; i < this.fightboxList.length; i++) {
              if (this.fightboxList[i].skin_list.length > 0) {
                this.fightImg.push(this.fightboxList[i].skin_list);
              }
            }

            //生成滚动的图片数组 Math.floor(30 / this.fightImg[0].length) + 1(循环次数，保证数据至少30个)
            if (this.fightImg.length == 1) {
              for (
                let i = 0;
                i < Math.floor(100 / this.fightImg[0].length) + 1;
                i++
              ) {
                for (let j = 0; j < this.fightImg[0].length; j++) {
                  this.fightImgObj.push(this.fightImg[0][j]);
                  this.fightImgObj = this.fightImgObj.slice(0, 100);
                  this.fightImgObj = this.getRandomArr(this.fightImgObj, 100);
                }
              }
            } else if (this.fightImg.length != 1) {
              for (let i = 0; i < this.fightImg.length; i++) {
                for (
                  let j = 0;
                  j < Math.floor(50 / this.fightImg[i].length) + 1;
                  j++
                ) {
                  for (let x = 0; x < this.fightImg[i].length; x++) {
                    this.fightImgObj.push(this.fightImg[i][x]);
                    this.fightImgObj = this.fightImgObj.slice(0, 50 * (i + 1));
                    //没有打乱顺序
                    // this.fightImgObj = this.getRandomArr(this.fightImgObj,20 * (i+1))
                  }
                }
              }
            }
            //把滚动数据放在各自下
            var winner_owner = this.normalizePrizeList(JSONres.data.data.winner_owner);
            var array = [];
            if (winner_owner) {
              for (var i = 0; i < this.peopleList.length; i++) {
                var json = JSON.parse(JSON.stringify(this.fightImgObj));
                var z = 1;
                var c = i;
                for (var iv = 90; iv < json.length; iv += 90) {
                  if (winner_owner.length == 2) {
                    winner_owner[i] = {
                      id: winner_owner[i]["id"],
                      imageUrl: winner_owner[i]["imageUrl"],
                      itemName: winner_owner[i]["itemName"],
                      img: winner_owner[i]["img"],
                      name: winner_owner[i]["name"],
                      price: winner_owner[i]["price"],
                    };
                  } else {
                    if (winner_owner[c]) {
                      winner_owner[c] = {
                        id: winner_owner[c]["id"],
                        imageUrl: winner_owner[c]["imageUrl"],
                        itemName: winner_owner[c]["itemName"],
                        img: winner_owner[c]["img"],
                        name: winner_owner[c]["name"],
                        price: winner_owner[c]["price"],
                      };
                    }
                  }
                  if (iv < json.length) {
                    if (winner_owner.length == playerinfo.length) {
                      json[iv] = winner_owner[i];
                    } else {
                      if (winner_owner[c]) {
                        json[iv] = winner_owner[c];
                      }
                    }
                    c += playerinfo.length;
                    z++;
                  }
                }
                array.push(json);
              }
              for (let i = 0; i < this.peopleList.length; i++) {
                this.peopleList[i].fightBox = array[i];
              }
            } else {
              for (let i = 0; i < this.peopleList.length; i++) {
                this.peopleList[i].fightBox = this.fightImgObj;
              }
            }
            //对战进行中2  对战未开始1  3结束
            if (data.data.status == "3") {
              this.playAlarm2();
              var box = this.normalizePrizeList(data.data.winner_owner);
              let numPrice = 0;
              //是否为平局
              if (box.length == 0) {
                for (let i = 0; i < this.peopleList.length; i++) {
                  this.peopleList[i].box = this.peopleList[i].skin_list;
                  this.peopleList[i].end = 2;
                  this.peopleList[i].winState = true;
                  this.peopleList[i].totalPrice = 0;
                  if (this.peopleList[i].skin_list == undefined) {
                    this.peopleList[i].winState = false;
                    this.peopleList[i].box = [];
                    this.peopleList[i].box.push(this.peopleObj);
                    this.peopleList[i].totalPrice = "0.01";
                    this.peopleList[i].box[0].name = "凉凉奖励";
                  } else {
                    for (let j = 0; j < this.peopleList[i].box.length; j++) {
                      this.peopleList[i].totalPrice += Number(
                        this.peopleList[i].box[j].price
                      );
                    }
                    this.peopleList[i].totalPrice = Number(
                      this.peopleList[i].totalPrice
                    ).toFixed(2);
                  }
                }
                for (let i = 0; i < this.fightboxList.length; i++) {
                  this.fightboxList[i].state = false;
                  this.fightboxList[this.fightboxList.length - 1].state = true;
                }
              } else {
                for (let i = 0; i < this.peopleList.length; i++) {
                  if (this.peopleList[i].id == data.data.winner) {
                    this.peopleList[i].box = box;
                    this.peopleList[i].totalPrice = 0;
                    this.peopleList[i].winState = true;
                    for (let j = 0; j < box.length; j++) {
                      this.peopleList[i].totalPrice += Number(box[j].price);
                    }
                  } else {
                    this.peopleList[i].winState = false;
                    this.peopleList[i].box = [];
                    this.peopleList[i].box.push(this.peopleObj);
                    this.peopleList[i].totalPrice = "0.01";
                    this.peopleList[i].box[0].name = "凉凉奖励";
                  }
                  this.peopleList[i].totalPrice = Number(
                    this.peopleList[i].totalPrice
                  ).toFixed(2);
                  this.peopleList[i].end = 2;
                }
                for (let i = 0; i < this.fightboxList.length; i++) {
                  this.fightboxList[i].state = false;
                  this.fightboxList[this.fightboxList.length - 1].state = true;
                }
              }
              if (!tt) {
                setTimeout(() => {
                  this.getRoomList(null, "tt");
                }, 100);
              }
            } else if (data.data.status == "2") {
              //对战进行中
              this.fightResult1();
            } else {
              //对战未开始
              for (let i = 0; i < this.peopleList.length; i++) {
                this.peopleList[i].end = 1;
              }
              for (let i = 0; i < this.fightboxList.length; i++) {
                this.totalPrice += Number(this.fightboxList[i].price);
                this.fightboxList[i].state = false;
                this.fightboxList[0].state = true;
              }
            }
          }
          if (data.status != "1") {
            this.markRoomUnavailable();
          }
        })
        .catch((reason) => {
          console.log(reason);
          this.markRoomUnavailable();
        });
    },
    getRoomList1(tt) {
      let param = {
        battle_id: this.id,
      };
      this.$axios
        .post("/index/Battle/battleDetail", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          if (data.status == "1") {
            this.fightboxList = this.normalizeRoomBoxes(data.data.boxInfo);
            for (let i = 0; i < this.fightboxList.length; i++) {
              this.boxList.push(this.fightboxList[i].skin_list);
            }
            this.peopleList = this.normalizePlayers(data.data.player_info);
            var mode = data.data.mode;
            var peopleListCopy = JSON.parse(JSON.stringify(this.peopleList)); //深拷贝
            if (mode != peopleListCopy.length) {
              for (let i = 0; i < mode - peopleListCopy.length; i++) {
                this.peopleList.push(this.peopleObj);
              }
            }
            for (let i = 0; i < this.peopleList.length; i++) {
              if (this.peopleList[i].id) {
                this.peopleList[i].state = true;
              } else {
                this.peopleList[i].state = false;
              }
              //   if (mode == 2) {
              //     this.peopleList[i].width = "48%";
              //   } else if (mode == 3) {
              //     this.peopleList[i].width = "33.33%";
              //   } else {
              //     this.peopleList[i].width = "25%";
              //   }
            }

            //对战的滚动图片数据
            for (let i = 0; i < this.fightboxList.length; i++) {
              if (this.fightboxList[i].skin_list.length > 0) {
                this.fightImg.push(this.fightboxList[i].skin_list);
              }
            }

            //生成滚动的图片数组 Math.floor(30 / this.fightImg[0].length) + 1(循环次数，保证数据至少30个)
            if (this.fightImg.length == 1) {
              for (
                let i = 0;
                i < Math.floor(50 / this.fightImg[0].length) + 1;
                i++
              ) {
                for (let j = 0; j < this.fightImg[0].length; j++) {
                  this.fightImgObj.push(this.fightImg[0][j]);
                  this.fightImgObj = this.fightImgObj.slice(0, 50);
                  this.fightImgObj = this.getRandomArr(this.fightImgObj, 50);
                }
              }
            } else if (this.fightImg.length != 1) {
              for (let i = 0; i < this.fightImg.length; i++) {
                for (
                  let j = 0;
                  j < Math.floor(50 / this.fightImg[i].length) + 1;
                  j++
                ) {
                  for (let x = 0; x < this.fightImg[i].length; x++) {
                    this.fightImgObj.push(this.fightImg[i][x]);
                    this.fightImgObj = this.fightImgObj.slice(0, 50 * (i + 1));
                    //没有打乱顺序
                    // this.fightImgObj = this.getRandomArr(this.fightImgObj,20 * (i+1))
                  }
                }
              }
            }

            //把滚动数据放在各自下
            for (let i = 0; i < this.peopleList.length; i++) {
              this.peopleList[i].fightBox = this.fightImgObj;
            }

            //对战进行中2  对战未开始1  3结束
            if (data.data.status == "3") {
              var box = this.normalizePrizeList(data.data.winner_owner);
              let numPrice = 0;
              //是否为平局
              if (data.data.winner_owner.length == 0) {
                for (let i = 0; i < this.peopleList.length; i++) {
                  this.peopleList[i].box = this.peopleList[i].skin_list;
                  this.peopleList[i].end = 2;
                  this.peopleList[i].winState = true;
                  this.peopleList[i].totalPrice = 0;
                  if (this.peopleList[i].skin_list == undefined) {
                    this.peopleList[i].winState = false;
                    this.peopleList[i].box = [];
                    this.peopleList[i].box.push(this.peopleObj);
                    this.peopleList[i].totalPrice = "0.01";
                    this.peopleList[i].box[0].name = "凉凉奖励";
                  } else {
                    for (let j = 0; j < this.peopleList[i].box.length; j++) {
                      this.peopleList[i].totalPrice += Number(
                        this.peopleList[i].box[j].price
                      );
                    }
                    this.peopleList[i].totalPrice = Number(
                      this.peopleList[i].totalPrice
                    ).toFixed(2);
                  }
                }
                for (let i = 0; i < this.fightboxList.length; i++) {
                  this.fightboxList[i].state = false;
                  this.fightboxList[this.fightboxList.length - 1].state = true;
                }
              } else {
                for (let i = 0; i < this.peopleList.length; i++) {
                  if (this.peopleList[i].id == data.data.winner) {
                    this.peopleList[i].box = box;
                    this.peopleList[i].totalPrice = 0;
                    this.peopleList[i].winState = true;
                    for (let j = 0; j < box.length; j++) {
                      this.peopleList[i].totalPrice += Number(box[j].price);
                    }
                  } else {
                    this.peopleList[i].winState = false;
                    this.peopleList[i].box = [];
                    this.peopleList[i].box.push(this.peopleObj);
                    this.peopleList[i].totalPrice = "0.01";
                    this.peopleList[i].box[0].name = "凉凉奖励";
                  }
                  this.peopleList[i].totalPrice = Number(
                    this.peopleList[i].totalPrice
                  ).toFixed(2);
                  this.peopleList[i].end = 2;
                }
                for (let i = 0; i < this.fightboxList.length; i++) {
                  this.fightboxList[i].state = false;
                  this.fightboxList[this.fightboxList.length - 1].state = true;
                }
              }
              if (!tt) {
                this.getRoomList1("tt");
              }
            } else if (data.data.status == "2") {
              //对战进行中
              this.fightResult1();
            } else {
              //对战未开始
              for (let i = 0; i < this.peopleList.length; i++) {
                this.peopleList[i].end = 1;
              }
              for (let i = 0; i < this.fightboxList.length; i++) {
                this.totalPrice += Number(this.fightboxList[i].price);
                this.fightboxList[i].state = false;
                this.fightboxList[0].state = true;
              }
            }
          }
        })
        .catch((reason) => {
          //this.getRoomList();
          console.log(reason);
        });
    },

    //跳转至活动规则
    goLuckyRule() {
      this.$router.push({
        path: `/LuckyRule`,
      });
    },
    //跳转至活动历史
    goLuckyHistory() {
      this.$router.push({
        path: `/LuckyHistory`,
      });
    },
    //房间观看对战 请求对战结果
    fightResult1() {
      let param = {
        battle_id: this.id,
      };
      this.$axios
        .post("/index/Battle/resultInfo", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          // console.log(data);
          if (data.status == "1") {
            // console.log(111,data)
            this.playAlarm1();
            let box = data.data.result.map((round) => this.normalizePrizeList(round));
            this.mode = box.length;
            this.openWin = true;
            this.roomLineState = true;

            //把结果放在对应的玩家下
            for (let i = 0; i < this.peopleList.length; i++) {
              this.peopleList[i].boxImg = [];
              for (let j = 0; j < box.length; j++) {
                this.peopleList[i].boxImg.push(box[j][i]);
              }
            }

            //在滚动的图片放入相应的结果
            // let obj = JSON.parse(JSON.stringify(this.peopleList));
            // for (let i = 0; i < obj.length; i++) {
            // 	for (let j = 0; j < obj[i].boxImg.length; j++) {
            // 		obj[i].fightBox[45 * (j + 1)] = obj[i].boxImg[j];
            // 	}
            // }
            // this.peopleList = obj;

            // console.log(this.peopleList)
            //调整显示图片的地址
            for (let i = 0; i < this.peopleList.length; i++) {
              for (let j = 0; j < this.peopleList[i].fightBox.length; j++) {
                const fallback = this.skinFallbackImages[j % this.skinFallbackImages.length];
                this.peopleList[i].fightBox[j].imageUrl = this.stableImage(
                  this.peopleList[i].fightBox[j].imageUrl || this.peopleList[i].fightBox[j].img,
                  fallback
                );
                this.peopleList[i].fightBox[j].img = this.stableImage(
                  this.peopleList[i].fightBox[j].img || this.peopleList[i].fightBox[j].imageUrl,
                  fallback
                );
              }
            }

            //动画
            if (this.mode == 1) {
              // console.log('开启音乐')
              setTimeout(() => {
                for (let i = 0; i < this.peopleList.length; i++) {
                  this.peopleList[i].box = [];
                  this.peopleList[i].box.push(box[0][i]);
                  this.peopleList[i].totalPrice = this.peopleList[
                    i
                  ].box[0].price;
                }
                this.$forceUpdate();
                this.playAlarm2();
              }, 7000);
              setTimeout(() => {
                this.over();
                this.openWin = false;
                this.roomLineState = false;
              }, 8000);
            } else {
              for (let i = 0; i < this.mode; i++) {
                setTimeout(() => {
                  for (let j = 0; j < this.peopleList.length; j++) {
                    if (!this.peopleList[j].box) {
                      this.peopleList[j].box = [];
                    }
                    this.peopleList[j].box.push(box[i][j]);
                    this.peopleList[j].totalPrice = 0;
                    for (let x = 0; x < this.peopleList[j].box.length; x++) {
                      this.peopleList[j].totalPrice += Number(
                        this.peopleList[j].box[x].price
                      );
                    }
                    this.peopleList[j].totalPrice = this.peopleList[
                      j
                    ].totalPrice.toFixed(2);
                  }
                  for (let y = 0; y < this.fightboxList.length; y++) {
                    this.fightboxList[y].state = false;
                  }
                  if (i + 1 < this.mode) {
                    this.fightboxList[i + 1].state = true;
                  } else if (i + 1 == this.mode) {
                    this.fightboxList[i].state = true;
                  }
                  this.$forceUpdate();
                }, (i + 1) * 8000);
              }

              //音乐
              /*  for (let i = 0; i < this.mode; i++) {
								  setTimeout(() => {
								    this.playAlarm1();
								  }, i * 5000 );
								}
								for (let i = 0; i < this.mode; i++) {
								  setTimeout(() => {
								    this.playAlarm2();
								  }, (i + 1 ) * 5000 - 1000);
								} */

              setTimeout(() => {
                this.openWin = false;
                this.roomLineState = false;
                this.over();
              }, this.mode * 8000);
            }
          }
        });
    },

    //对局结束
    over() {
      var _this = this;
      let param = {
        battle_id: this.id,
      };
      this.$axios
        .post("/index/Battle/setBattleStatus", this.$qs.stringify(param))
        .then((res) => {
          // console.log(res.data);
          if (res.data.status == "1") {
            // console.log("对战结束")

            //发送
            /* let sendData = {
							   state: "update",
							   battle_id: _this.id,
							 };
							 _this.websocketsend(JSON.stringify(sendData));*/
            _this.getRoomList("over");
          }
        });
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    //点击参与活动
    goParticipate(index) {
      if (!this.$store.state.token) {
        this.$store.commit("getLogin", true);
        return;
      }
      // this.loading = true;
      this.disabled = true;
      let _this = this;
      let param = {
        battle_id: this.id,
      };
      _this.$axios
        .post("/index/Battle/addBattle", _this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          // console.log(data);
          if (data.status == "1") {
            this.loading = false;
            //扣除余额
            this.$store.commit("getMoney", data.data.total_amount);
            Utils.$emit("money", data.data.total_amount);
            this.getRoomList();
            //人数已满 开始对战
            if (data.data.battle_status == "start") {
              let box = data.data.result.result;
              this.mode = box.length;
              // this.playAlarm1(); // 开启音乐
            }
          } else {
            this.disabled = false;
            this.loading = false;
            this.$message({
              message: data.msg,
              type: "warning",
            });
          }
        })
        .catch((reason) => {
          //console.log("reason" + reason);
          //this.goParticipate(index);
          console.log(reason);
        });
      // this.loading = false;
    },
    useCaseFallback(event, index) {
      const fallback = this.caseFallbackImages[index % this.caseFallbackImages.length];
      if (event.target.src != fallback) {
        event.target.src = fallback;
      }
    },
    useSkinFallback(event, index) {
      const fallback = this.skinFallbackImages[index % this.skinFallbackImages.length];
      if (event.target.src != fallback) {
        event.target.src = fallback;
      }
    },
    useAvatarFallback(event) {
      if (event.target.src != this.peopleObj.img) {
        event.target.src = this.peopleObj.img;
      }
    },
    stableImage(value, fallback) {
      if (!value) return fallback;
      if (value.indexOf("http://") === 0) return fallback;
      if (value.indexOf("https://img.zbt.com") === 0) return fallback;
      if (value.indexOf("game-aesy.c5game.com") !== -1) return fallback;
      if (value.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) return fallback;
      if (value.indexOf("csgoapi.akaifa998.icu") !== -1) return fallback;
      return value;
    },
    normalizePrizeList(list) {
      return list.map((item, index) => {
        const fallback = this.skinFallbackImages[index % this.skinFallbackImages.length];
        item.imageUrl = this.stableImage(item.imageUrl || item.img, fallback);
        item.img = this.stableImage(item.img || item.imageUrl, fallback);
        item.itemName = item.itemName || item.name;
        item.name = item.name || item.itemName;
        return item;
      });
    },
    getBattleProps() {
      this.$axios.post("/index/battle_prop/myProps", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.status == 1) {
            this.battleProps = res.data.data || [];
          }
        });
    },
    selectBattleProp(item) {
      this.selectedBattleProp = item;
      this.$message({
        message: "道具已选择，请点击房间内的其他玩家发送",
        type: "info",
      });
    },
    canTargetProp(player) {
      return this.selectedBattleProp && player.state && Number(player.id) != Number(this.$store.state.id);
    },
    battlePropEventsFor(playerId) {
      return this.battlePropEvents.filter((event) => Number(event.target_id) == Number(playerId));
    },
    getBattlePropEvents() {
      if (Number(this.id) < 1) {
        return;
      }
      this.$axios.post("/index/battle_prop/battleEvents", this.$qs.stringify({
        battle_id: this.id,
        after_id: this.propEventCursor,
      })).then((res) => {
        if (res.data.status != 1) {
          return;
        }
        const data = res.data.data;
        if (!this.propEventsInitialized) {
          this.propEventsInitialized = true;
          this.propEventCursor = data.cursor;
          return;
        }
        data.events.forEach((event) => this.receiveBattlePropEvent(event));
        this.propEventCursor = data.cursor;
      });
    },
    receiveBattlePropEvent(event) {
      if (this.battlePropEvents.find((item) => Number(item.id) == Number(event.id))) {
        return;
      }
      this.battlePropEvents.push(event);
      if (event.sound_url) {
        new Audio(event.sound_url).play();
      }
      setTimeout(() => {
        this.battlePropEvents = this.battlePropEvents.filter((item) => Number(item.id) != Number(event.id));
      }, 2200);
    },
    sendBattleProp(player) {
      if (!this.canTargetProp(player) || this.sendingBattleProp) {
        return;
      }
      this.sendingBattleProp = true;
      this.$axios.post("/index/battle_prop/sendProp", this.$qs.stringify({
        battle_id: this.id,
        target_id: player.id,
        prop_id: this.selectedBattleProp.prop_id,
      })).then((res) => {
        this.sendingBattleProp = false;
        if (res.data.status != 1) {
          this.$message({ message: res.data.msg, type: "warning" });
          return;
        }
        const data = res.data.data;
        this.selectedBattleProp.quantity = data.quantity;
        this.receiveBattlePropEvent(data.event);
        this.propEventCursor = Number(data.event.id);
        if (Number(data.quantity) < 1) {
          this.battleProps = this.battleProps.filter((item) => item.prop_id != this.selectedBattleProp.prop_id);
          this.selectedBattleProp = null;
        }
      }).catch(() => {
        this.sendingBattleProp = false;
      });
    },
    normalizePlayers(list) {
      return list.map((player) => {
        player.img = this.stableImage(player.img || player.image, this.peopleObj.img);
        return player;
      });
    },
    normalizeRoomBoxes(boxes) {
      return boxes.map((box, index) => {
        const fallback = this.caseFallbackImages[index % this.caseFallbackImages.length];
        box.img_main = this.stableImage(box.img_main, fallback);
        box.img_active = this.stableImage(box.img_active, fallback);
        box.skin_list = this.normalizePrizeList(box.skin_list);
        return box;
      });
    },
    markRoomUnavailable() {
      this.roomUnavailable = true;
      this.boxList = [];
      this.fightboxList = [];
      this.fightImg = [];
      this.fightImgObj = [];
      this.peopleList = [];
      this.totalPrice = 0;
    },
    usePreviewRoom() {
      const skins = [
        {
          id: "preview-skin-1",
          itemName: "AK-47 | Neon Rider",
          name: "AK-47 | Neon Rider",
          imageUrl: require("../assets/hotpizza/hp-ak-green.png"),
          img: require("../assets/hotpizza/hp-ak-green.png"),
          price: "34.75",
        },
        {
          id: "preview-skin-2",
          itemName: "AWP | Fever Dream",
          name: "AWP | Fever Dream",
          imageUrl: require("../assets/hotpizza/hp-awp-fire.png"),
          img: require("../assets/hotpizza/hp-awp-fire.png"),
          price: "18.42",
        },
        {
          id: "preview-skin-3",
          itemName: "M4A4 | Royal Paladin",
          name: "M4A4 | Royal Paladin",
          imageUrl: require("../assets/hotpizza/hp-m4-blue.png"),
          img: require("../assets/hotpizza/hp-m4-blue.png"),
          price: "8.40",
        },
        {
          id: "preview-skin-4",
          itemName: "Specialist Gloves",
          name: "Specialist Gloves",
          imageUrl: require("../assets/hotpizza/hp-gloves.png"),
          img: require("../assets/hotpizza/hp-gloves.png"),
          price: "75.42",
        },
      ];
      this.fightboxList = [
        {
          box_id: "preview-case-1",
          name: "Crystal Fever",
          price: "34.75",
          num: 1,
          state: true,
          img_main: require("../assets/hotpizza/hp-case-crystal.png"),
          img_active: require("../assets/hotpizza/hp-case-crystal.png"),
          skin_list: skins,
        },
        {
          box_id: "preview-case-2",
          name: "Green Hunter",
          price: "8.40",
          num: 1,
          state: false,
          img_main: require("../assets/hotpizza/hp-case-green.png"),
          img_active: require("../assets/hotpizza/hp-case-green.png"),
          skin_list: skins,
        },
      ];
      this.boxList = this.fightboxList.map((box) => box.skin_list);
      this.boxListIndex = 0;
      this.fightImg = this.boxList;
      this.fightImgObj = skins.concat(skins, skins, skins, skins);
      this.mode = 2;
      this.totalPrice = this.fightboxList.reduce((total, box) => total + Number(box.price), 0).toFixed(2);
      this.openWin = false;
      this.roomLineState = false;
      this.lineState = false;
      this.peopleList = [
        {
          id: "preview-player-1",
          name: "PizzaKing",
          img: require("../assets/hotpizza/hp-mp9-red.png"),
          state: true,
          end: 1,
          totalPrice: "0.00",
          fightBox: this.fightImgObj,
          box: [],
        },
        {
          name: "等待玩家",
          img: this.peopleObj.img,
          state: false,
          end: 1,
          totalPrice: "0.00",
          fightBox: this.fightImgObj,
          box: [],
        },
      ];
    },
    //点击盒子查看右侧图片
    selImg(index) {
      this.boxListIndex = index;
      this.fightboxList.forEach((item) => {
        item["state"] = false;
      });
      this.fightboxList[index]["state"] = true;
    },
  },
};
</script>

<style lang="less" scoped>
.win-img {
  width: 115px !important;
  height: 103.47px !important;
  margin-top: 0 !important;
}
.fail-img {
  width: 116px !important;
  height: 102px !important;
  margin-top: 0 !important;
}
.room-win-status {
  background-color: rgba(247, 253, 0, 0.09) !important;
  height: max-content;
  //   padding: 0 3px 5px 3px;
}
.room-fail-status {
  background-color: rgba(64, 51, 244, 0.1) !important;
  height: max-content;
  //   padding: 0 3px 5px 3px;
}
.room::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  //   background: var(--backimg) no-repeat center center;
  /*  z-index:1; */
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-size: cover;
  -webkit-background-size: cover;
  /* 兼容Webkit内核浏览器如Chrome和Safari */
  -o-background-size: cover;
  /* 兼容Opera */
  zoom: 1;
}
.room {
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  z-index: 2;

  .audio {
    display: none;
  }

  .room-right {
    width: 300px;
    height: calc(100% - 103px);
    position: fixed;
    top: 60px;
    right: 17px;
    background-color: #24252f;
    z-index: 999;

    .room-right-name {
      text-align: center;
      padding: 10px;
      color: #848492;
      font-size: 16px;

      span {
        color: #e9b10e;
      }
    }

    .room-right-list {
      padding: 0 10px;
      height: 100%;
      background-color: #30313f;
      overflow: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }

      .roomlist-title {
        font-size: 16px;
        color: #c3c3e2;
        padding: 10px 0;
      }

      ul {
        margin: 0 -4px;
        display: flex;
        flex-flow: row wrap;

        li {
          width: 50%;

          .roomlist-warp {
            margin: 4px;
            background-color: #24252f;

            overflow: hidden;

            .roomlist-img {
              width: 100%;
              background-image: url("../assets/img/box-skins-blue.jpg");
              background-size: 100% 100%;

              img {
                width: 100%;
                height: auto;
              }
            }

            .roomlist-name {
              font-size: 14px;
              color: #c3c3e2;
              padding: 10px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      img {
        width: 100px;
        height: 100px;
      }
    }

    /*滚动条样式*/
    .room-right-list::-webkit-scrollbar {
      width: 4px;
      /*height: 4px;*/
    }

    .room-right-list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }

    .room-right-list::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .room-left {
    padding: 16px 316px 0 16px;

    .room-left-hint {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .roomleft-num {
        display: flex;
        align-items: center;
        color: #848492;
        font-size: 15px !important;
        span {
          margin-right: 5px;
          &:last-child:hover {
            color: #e9b10e;
          }
        }
      }

      .roomleft-btn {
        margin-right: -5px;

        span {
          padding: 6px 15px;
          color: #fff;
          font-weight: 600;
          font-size: 14px;
          border: 1px solid #e9b10e;
          margin-right: 10px;
        }

        :hover {
          cursor: pointer;
          background-color: #3a3f50;
        }
      }
    }

    .room-left-box {
      margin-top: 30px;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      //   background-color: #2b2c37;
      justify-content: center;
      width: 100%;

      .roombox-warp {
        width: 100%;

        ul {
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: auto;
          overflow-y: hidden;
          background-color: #1a1c24;
          padding: 20px 0 20px 0;
          border-bottom: 1px solid #22252f;
          li {
            width: 60px;
            .roombox-num {
              display: flex;
              align-items: center;
              // margin: 10px 15px 15px 15px;
              position: relative;

              .roombox-img {
                width: 55px;
                height: 55px;
                img {
                  height: 100%;
                  width: 100%;
                  object-fit: contain;
                  cursor: pointer;
                }
              }

              .roombox-num1 {
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                margin-right: 30px;
                color: #e9b10e;
                position: relative;
                font-size: 14px;
                margin: 0 auto;
              }

              // .roombox-num1::before {
              //   top: 0;
              //   left: 0;
              //   width: 100%;
              //   border: 1px solid #e9b10e;
              //   height: 100%;
              //   content: "";
              //   position: absolute;
              //   transform: rotate(45deg);
              //   box-sizing: border-box;
              // }
              .roombox-line {
                width: 60px;
                height: 1px;
                background-color: #e9b10e;
              }
            }
          }

          li:last-child .roombox-line {
            display: none;
          }

          #room-li {
            position: relative;

            &::before {
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              //   background-image: url("../assets/new/bg_border.png");
              background-size: 100% 100%;
              background-image: url("../assets/img/lucky/choose.png");
              //   transform: rotate(180deg);
            }

            .roombox-num1 {
              width: 30px;
              height: 30px;
              line-height: 30px;
            }

            .roombox-img {
              top: -60px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                object-fit: contain;
                // height: 85px;
                // width: 85px;
                width: 100%;
              }
            }

            .roombox-num1::before {
              box-shadow: 0px 0px 7px #e9b10e;
            }
          }
        }
      }
    }

    .room-left-people {
      .roompe-warp {
        position: relative;

        .ul1 {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
          gap: 10px;
          .li1 {
            width: 100%;
            // max-width: 300px;
            margin: 0 auto;
            display: flex;
            .room-warp {
              width: 100%;

              .room1 {
                height: 110px;
                line-height: 110px;
                background-image: linear-gradient(#2d2d36, #483856);
                /* background-image: linear-gradient(
                  rgba(43, 44, 55, 1),
                  rgba(35, 71, 59, 1)
                );*/
                // border-top-left-radius: 5px;
                // border-top-right-radius: 5px;
                text-align: center;
                position: relative;
                overflow: hidden;

                .pool {
                  overflow: hidden;
                  position: absolute;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  background-image: linear-gradient(#2d2d36, #483856);
                  background-size: 100% 100%;
                  z-index: 2;

                  ul {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    animation: run 7s;
                    animation-timing-function: ease-out; //动画 速度一样
                    animation-iteration-count: 1; //播放几次动画
                    animation-delay: 0s; //动画运行前等待时间
                    animation-fill-mode: forwards; //动画结束 是否保持

                    li {
                      width: 100%;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;

                      .pool-img {
                        height: 100px;

                        img {
                          object-fit: contain;
                          height: 100px;
                          width: auto;
                          margin: 0 auto;
                        }
                      }
                    }
                  }

                  @keyframes run {
                    0% {
                      top: 0;
                    }

                    100% {
                      top: -9000px;
                    }
                  }

                  .pool-ul2 {
                    animation: run2 16s;
                  }

                  @keyframes run2 {
                    0% {
                      top: 0;
                    }

                    50% {
                      top: -9000px;
                    }

                    100% {
                      top: -18000px;
                    }
                  }

                  .pool-ul3 {
                    animation: run3 24s;
                  }

                  @keyframes run3 {
                    0% {
                      top: 0;
                    }

                    33.33% {
                      top: -9000px;
                    }

                    66.66% {
                      top: -18000px;
                    }

                    100% {
                      top: -27000px;
                    }
                  }

                  .pool-ul4 {
                    animation: run4 32s;
                  }

                  @keyframes run4 {
                    0% {
                      top: 0;
                    }

                    25% {
                      top: -9000px;
                    }

                    50% {
                      top: -18000px;
                    }

                    75% {
                      top: -27000px;
                    }

                    100% {
                      top: -36000px;
                    }
                  }

                  .pool-ul5 {
                    animation: run5 40s;
                  }

                  @keyframes run5 {
                    0% {
                      top: 0;
                    }

                    20% {
                      top: -9000px;
                    }

                    40% {
                      top: -18000px;
                    }

                    60% {
                      top: -27000px;
                    }

                    80% {
                      top: -36000px;
                    }

                    100% {
                      top: -45000px;
                    }
                  }

                  .pool-ul6 {
                    animation: run6 48s;
                  }

                  @keyframes run6 {
                    0% {
                      top: 0;
                    }

                    16.66% {
                      top: -9000px;
                    }

                    33.33% {
                      top: -18000px;
                    }

                    50% {
                      top: -27000px;
                    }

                    66.66% {
                      top: -36000px;
                    }

                    83.33% {
                      top: -45000px;
                    }

                    100% {
                      top: -54000px;
                    }
                  }
                }

                .room1-img {
                  //   background-image: linear-gradient(
                  //     rgba(43, 44, 55, 1),
                  //     rgba(35, 71, 59, 1)
                  //   );
                  img {
                    margin-top: 40px;
                    width: 30px;
                    height: 30px;
                  }

                  .room1-text2 {
                    margin-top: 0px;
                    font-size: 20px;
                    color: #848492;
                  }

                  .room1-text1 {
                    margin-top: 0px;
                    font-size: 20px;
                    color: #e9b10e;
                  }
                }

                button {
                  margin-top: -50px;
                  padding: 8px 10px;
                  background-color: #e9b10e;
                  border-radius: 8px;
                  color: #1a1c24;
                  font-size: 8px;
                  font-weight: 400;
                }

                button:hover {
                  cursor: pointer;
                }
              }

              .room1-win {
                // background-image: linear-gradient(#2f2f36, #836a22);
                background-image: url("../assets/img/lucky/win_back.13766729.png");
              }

              .room-back {
                background-image: url("../assets/img/lucky/conduct.33d8e98d.png");
                // background-image: linear-gradient(#2d2d36, #483856);
              }

              .room2 {
                margin-top: 20px;
                text-align: center;

                .room2-tou {
                  img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                  }
                }

                .room2-name {
                  font-size: 14px;
                  color: #c3c3e2;
                }

                span {
                  font-size: 14px;
                  color: #848492;
                  display: inline-block;
                  padding-top: 50px;
                }
              }
            }
          }

          .room-line:before {
            content: "";
            display: block;
            width: 100%;
            height: 2px;
            position: absolute;
            z-index: 8;
            top: 60px;
            left: 0;
            background-color: #e9b10e;
            box-shadow: 0px 0px 7px #e9b10e;
          }
        }
      }

      .roompe-line {
        position: absolute;
        left: 0;
        top: 60px;
        width: 100%;
        height: 3px;
        z-index: 9;
        background-color: #e9b10e;
      }

      .roompe-warp::before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 20px solid #e9b10e;
        border-bottom: 10px solid transparent;
        position: absolute;
        left: 0;
        top: 51px;
        z-index: 10;
      }

      .roompe-warp::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 20px solid #e9b10e;
        border-bottom: 10px solid transparent;
        position: absolute;
        right: 0;
        top: 51px;
        z-index: 10;
      }
    }

    .room-left-bot {
      margin-top: 30px;
      color: #848492;
      font-size: 12px;
      text-align: center;
      margin-bottom: 20px;

      & > p:last-child {
        color: #e9b10e;
      }

      p:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  //开奖列表
  .win-list {
    margin-top: 20px;

    .win-title {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 24px;
        width: auto;
      }

      span {
        margin-left: 5px;
        font-size: 24px;
        color: #e9b10e;
      }
    }

    .win-ul {
      padding: 0 4px;
      margin: -3px;
      margin-top: 15px;
      display: flex;
      flex-wrap: wrap;

      .win-li {
        width: 100%;
        //min-width: 200px;

        .win-warp {
          margin: 5px 0;
          background-color: #2b2c37;

          .img {
            height: 150px;
            // border-top-left-radius: 5px;
            // border-top-right-radius: 5px;
            background-position: top center;
            background-image: url("../assets/img/box-skins-blue.jpg");
            // background-size: 100% 95%;
            padding: 0 5px;
            display: grid;
            place-items: center;
            img {
              width: 70%;
              height: auto;
              max-width: 200px;
            }
          }

          h6 {
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            text-align: center;
            color: #fff;
            font-weight: 400;
            width: calc(100% - 10px);
            img {
              height: 16px;
              width: auto;
            }

            span {
              margin-left: 5px;
              font-size: 16px;
              color: #e9b10e;
            }
          }
        }
      }
    }
  }
}

.pk-battle-room {
  min-height: calc(100vh - 198px);
  height: auto;
  padding: 0;
  overflow: visible;
  background:
    radial-gradient(circle at 42% 18%, rgba(112, 74, 255, 0.2), transparent 32%),
    radial-gradient(circle at 84% 34%, rgba(242, 105, 0, 0.12), transparent 30%),
    #1c1d29;
}

.pk-battle-room::before {
  display: none;
}

.pk-battle-room-unavailable {
  min-height: 420px;
  padding: 120px 24px;
  display: grid;
  justify-items: center;
  align-content: center;
  gap: 12px;
  color: #a6afc0;
  background:
    radial-gradient(circle at 50% 18%, rgba(255, 138, 31, 0.16), transparent 34%),
    linear-gradient(180deg, #20222e, #171923);
  text-align: center;
}

.pk-battle-room-unavailable strong {
  color: #f4f6ff;
  font-size: 22px;
}

.pk-battle-room-unavailable span {
  font-size: 14px;
}

.pk-battle-room-unavailable button {
  min-width: 142px;
  height: 42px;
  margin-top: 8px;
  color: #fff3dd;
  background: linear-gradient(180deg, #ff9b28, #e25e00);
  border: 1px solid rgba(255, 198, 104, 0.64);
  border-radius: 7px;
  cursor: pointer;
  font: inherit;
  font-weight: 900;
}

.pk-battle-room .room-left {
  padding: 26px 350px 56px 18px;
}

.pk-battle-room .room-left-hint {
  min-height: 48px;
  margin-top: 0 !important;
  padding: 0 0 16px;
  align-items: center;
  border-bottom: 1px solid rgba(113, 122, 148, 0.24);
}

.pk-battle-room .roomleft-num {
  color: #8f98ab !important;
  font-size: 13px !important;
  font-weight: 900;
  text-transform: uppercase;
}

.pk-battle-room .roomleft-num span:first-child {
  color: #f3f6fb;
  font-size: 22px;
}

.pk-battle-room .roomleft-btn span {
  padding: 11px 15px !important;
  color: #cbd3e2 !important;
  background: #252836;
  border: 1px solid rgba(116, 128, 154, 0.55) !important;
  border-radius: 8px;
  font-size: 12px !important;
  font-weight: 900 !important;
}

.pk-battle-room .room-left-box {
  margin: 18px 0 20px !important;
}

.pk-battle-room .room-left-box .roombox-warp ul {
  min-height: 94px;
  padding: 16px 18px !important;
  gap: 14px;
  justify-content: flex-start !important;
  background:
    radial-gradient(circle at 50% 30%, rgba(242, 105, 0, 0.12), transparent 50%),
    #20222f !important;
  border: 1px solid rgba(116, 128, 154, 0.28);
  border-radius: 12px;
}

.pk-battle-room .room-left-box .roombox-warp ul li {
  width: 74px !important;
}

.pk-battle-room .roombox-num .roombox-img {
  width: 70px !important;
  height: 64px !important;
  display: grid;
  place-items: center;
  background: #2a2d3b;
  border: 1px solid rgba(116, 128, 154, 0.28);
  border-radius: 10px;
}

.pk-battle-room .roombox-num .roombox-img img {
  width: 64px !important;
  height: 58px !important;
  filter: drop-shadow(0 12px 16px rgba(0, 0, 0, 0.42));
}

.pk-battle-room #room-li::before {
  background: none !important;
  border: 1px solid #f26900;
  border-radius: 10px;
  box-shadow: 0 0 28px rgba(242, 105, 0, 0.28);
}

.pk-battle-room .room-left-people .roompe-warp .ul1 {
  gap: 14px !important;
}

.pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 520px;
  padding: 14px;
  background:
    radial-gradient(circle at 50% 22%, rgba(118, 83, 255, 0.16), transparent 44%),
    linear-gradient(180deg, #272a38, #20222f);
  border: 1px solid rgba(116, 128, 154, 0.3);
  border-radius: 12px;
  overflow: hidden;
}

.pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1 {
  height: 128px !important;
  line-height: 128px !important;
  background:
    linear-gradient(90deg, transparent 49.7%, rgba(255, 255, 255, 0.22) 49.7% 50.3%, transparent 50.3%),
    radial-gradient(circle at 50% 50%, rgba(242, 105, 0, 0.16), transparent 58%),
    #191b26 !important;
  border-radius: 10px;
}

.pk-battle-room .room-left-people .pool {
  background:
    linear-gradient(90deg, transparent 49.7%, rgba(255, 255, 255, 0.34) 49.7% 50.3%, transparent 50.3%),
    #191b26 !important;
  border-radius: 10px;
}

.pk-battle-room .room-left-people .pool-img {
  height: 128px !important;
}

.pk-battle-room .room-left-people .pool-img img {
  height: 120px !important;
  filter: drop-shadow(0 16px 22px rgba(0, 0, 0, 0.52));
}

.pk-battle-room .room2 {
  margin-top: 14px !important;
}

.pk-battle-room .room2-tou img {
  width: 54px !important;
  height: 54px !important;
  border: 2px solid rgba(116, 128, 154, 0.55);
}

.pk-battle-room .room2-name,
.pk-battle-room .room2 span {
  color: #dfe6f4 !important;
  font-weight: 900;
}

.pk-battle-room .win-list {
  margin-top: 16px !important;
}

.pk-battle-room .win-title span {
  color: #f26900 !important;
}

.pk-battle-room .win-title img,
.pk-battle-room .win-warp h6 img {
  content: url("../assets/pizzaking/pizza-token.svg");
}

.pk-battle-room .win-ul {
  gap: 10px;
  margin: 12px 0 0 !important;
  padding: 0 !important;
}

.pk-battle-room .win-li {
  width: 100% !important;
}

.pk-battle-room .win-warp {
  margin: 0 !important;
  background: #292c3a !important;
  border: 1px solid rgba(116, 128, 154, 0.22);
  border-radius: 10px;
  overflow: hidden;
}

.pk-battle-room .win-warp .img {
  height: 112px !important;
  background:
    radial-gradient(circle at 50% 45%, rgba(114, 67, 255, 0.2), transparent 58%),
    #20222f !important;
}

.pk-battle-room .win-warp .img img {
  max-height: 96px;
  object-fit: contain;
}

.pk-battle-room .room-right {
  width: 320px !important;
  height: calc(100vh - 222px) !important;
  position: fixed;
  top: 210px !important;
  right: 18px !important;
  z-index: 3 !important;
  background: #20222f !important;
  border: 1px solid rgba(116, 128, 154, 0.3);
  border-radius: 12px;
  overflow: hidden;
}

.pk-battle-room .room-right-name {
  padding: 16px 14px !important;
  color: #8f98ab !important;
  font-size: 13px !important;
  font-weight: 900;
  text-transform: uppercase;
}

.pk-battle-room .room-right-name span {
  color: #f3f6fb !important;
}

.pk-battle-room .room-right-list {
  background: #171923 !important;
}

.pk-battle-room .roomlist-title {
  color: #f3f6fb !important;
  font-weight: 900;
}

.pk-battle-room .roomlist-warp {
  background: #252836 !important;
  border: 1px solid rgba(116, 128, 154, 0.22);
  border-radius: 10px;
}

.pk-battle-room .roomlist-img {
  background:
    radial-gradient(circle at 50% 45%, rgba(114, 67, 255, 0.2), transparent 58%),
    #20222f !important;
  border-radius: 9px 9px 0 0;
}

.pk-battle-room .roomlist-name {
  color: #dfe6f4 !important;
  font-weight: 800;
}

@media screen and (max-width: 1180px) {
  .pk-battle-room .room-left {
    padding-right: 18px;
  }

  .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    height: auto !important;
    margin: 18px;
  }
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: battle room final target-like spacing. */
body:has(.pk-battle-room) .pk-battle-room {
  background:
    radial-gradient(ellipse at 50% 120px, rgba(253, 107, 1, 0.08), transparent 460px),
    #191b26 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: calc(100vw - 250px) !important;
  padding: 20px 382px 92px 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint,
body:has(.pk-battle-room) .pk-battle-room .room-left-box,
body:has(.pk-battle-room) .pk-battle-room .room-left-people {
  border-radius: 8px !important;
  border-color: #2b2d3c !important;
  background: #20222f !important;
  box-shadow: none !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint {
  min-height: 78px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  min-height: 178px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 572px !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 30%, rgba(253, 107, 1, 0.1), transparent 44%),
    #20222f !important;
  border-color: #2b2d3c !important;
  box-shadow: none !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 164px !important;
  line-height: 164px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 164px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  top: 207px !important;
  right: 18px !important;
  width: 352px !important;
  height: calc(100vh - 228px) !important;
  border-radius: 8px !important;
  border-color: rgba(236, 216, 184, 0.1) !important;
  background: #20222f !important;
  box-shadow: none !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 92px !important;
  border-radius: 7px !important;
  background: #252837 !important;
  border: 1px solid #2b2d3c !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  height: 90px !important;
  min-height: 90px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 92px !important;
  max-height: 78px !important;
}
</style>

<style lang="less">
@import "./LuckyRoom-battle-props.less";
</style>

<style lang="less">
/* 2026-07-03 target room density pass: visual-only overrides. */
body:has(.pk-battle-room) .pk-battle-room {
  position: relative !important;
  min-height: calc(100vh - 197px) !important;
  overflow: visible !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: 100% !important;
  max-width: 1540px !important;
  margin: 0 auto !important;
  padding: 26px 382px 86px 28px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  position: absolute !important;
  top: 26px !important;
  right: max(28px, calc((100% - 1540px) / 2 + 28px)) !important;
  width: 336px !important;
  height: auto !important;
  max-height: 720px !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-list {
  max-height: 636px !important;
  overflow-y: auto !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 148px !important;
  display: block !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  width: 100% !important;
  height: 104px !important;
  min-height: 104px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 126px !important;
  max-height: 92px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  width: 100% !important;
  height: 42px !important;
  padding: 0 8px !important;
  justify-content: center !important;
  text-align: center !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 520px !important;
  padding: 14px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 152px !important;
  line-height: 152px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 152px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-ul {
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr)) !important;
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp {
  min-height: 158px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img {
  height: 104px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img img {
  max-height: 92px !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    max-height: none !important;
    margin: 18px 14px 0 !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right-list {
    max-height: none !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle room result state: final result cards and winner glow. */
body:has(.pk-battle-room) .pk-battle-room .room-win-status {
  border-color: rgba(255, 154, 25, 0.68) !important;
  background:
    radial-gradient(circle at 50% 13%, rgba(255, 178, 42, 0.26), transparent 36%),
    radial-gradient(circle at 50% 62%, rgba(255, 105, 0, 0.14), transparent 52%),
    linear-gradient(180deg, #2b2d3c, #20222f) !important;
  box-shadow:
    0 0 0 1px rgba(255, 214, 128, 0.12),
    0 0 42px rgba(255, 132, 31, 0.2),
    0 24px 54px rgba(0, 0, 0, 0.28) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-fail-status {
  border-color: rgba(111, 121, 151, 0.2) !important;
  background:
    radial-gradient(circle at 50% 16%, rgba(92, 74, 139, 0.16), transparent 38%),
    linear-gradient(180deg, rgba(37, 40, 54, 0.78), rgba(27, 29, 40, 0.9)) !important;
  opacity: 0.78 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-win-status::after,
body:has(.pk-battle-room) .pk-battle-room .room-fail-status::after {
  position: absolute !important;
  top: 12px !important;
  right: 14px !important;
  z-index: 5 !important;
  min-width: 58px !important;
  height: 28px !important;
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 999px !important;
  font-size: 12px !important;
  font-weight: 1000 !important;
  letter-spacing: 0.4px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-win-status::after {
  content: "\83b7\80dc" !important;
  color: #2b1600 !important;
  background: linear-gradient(180deg, #ffe2a3, #ff8a00) !important;
  box-shadow: 0 0 22px rgba(255, 138, 0, 0.38) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-fail-status::after {
  content: "\672a\4e2d\5956" !important;
  color: #aab3c5 !important;
  background: rgba(28, 31, 43, 0.88) !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-win-status .room1,
body:has(.pk-battle-room) .pk-battle-room .room-fail-status .room1 {
  height: 152px !important;
  min-height: 152px !important;
  background:
    linear-gradient(90deg, transparent 49.8%, rgba(255, 228, 176, 0.38) 49.8% 50.2%, transparent 50.2%),
    radial-gradient(circle at 50% 54%, rgba(255, 154, 25, 0.2), transparent 56%),
    #191b26 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-text1,
body:has(.pk-battle-room) .pk-battle-room .room1-text2 {
  width: 128px !important;
  height: 112px !important;
  margin: 0 auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 18px !important;
  background-size: cover !important;
  background-position: center !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-text1 img,
body:has(.pk-battle-room) .pk-battle-room .room1-text2 img {
  width: 104px !important;
  height: auto !important;
  margin: 0 !important;
  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.28)) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-win-status .room2-name {
  color: #fff5d8 !important;
  text-shadow: 0 0 14px rgba(255, 154, 25, 0.28) !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-title {
  height: 42px !important;
  margin: 8px 0 12px !important;
  padding: 0 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 7px !important;
  border-radius: 9px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 154, 25, 0.18), transparent 56%),
    rgba(25, 27, 38, 0.72) !important;
  border: 1px solid rgba(255, 214, 128, 0.1) !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-title span {
  color: #ffbc35 !important;
  font-size: 20px !important;
  line-height: 1 !important;
  font-weight: 1000 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-ul {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 12px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-li {
  width: auto !important;
  margin: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp {
  min-height: 188px !important;
  border-radius: 10px !important;
  background:
    radial-gradient(circle at 50% 35%, rgba(173, 42, 42, 0.28), transparent 44%),
    linear-gradient(180deg, #2a2d3b, #212432) !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-win-status .win-warp {
  border-color: rgba(255, 154, 25, 0.24) !important;
  box-shadow: inset 0 -2px 0 rgba(255, 132, 31, 0.36) !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img {
  height: 124px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img img {
  max-width: 88% !important;
  max-height: 108px !important;
  object-fit: contain !important;
  filter: drop-shadow(0 16px 22px rgba(0, 0, 0, 0.34)) !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp h6 {
  height: auto !important;
  min-height: 22px !important;
  padding: 0 10px !important;
  color: #f4f7ff !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-weight: 900 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp h6:first-of-type {
  color: #ffbc35 !important;
  font-size: 14px !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .win-ul {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-05 exact-pass: battle room full-width stage and reward rail. */
body:has(.pk-battle-room) .pk-battle-room {
  min-height: calc(100vh - 199px) !important;
  background:
    radial-gradient(ellipse at 48% 220px, rgba(236, 216, 184, 0.065), transparent 440px),
    radial-gradient(ellipse at 78% 190px, rgba(255, 112, 0, 0.09), transparent 320px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: auto !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 22px 382px 90px 24px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint {
  min-height: 64px !important;
  padding: 0 0 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-bottom: 1px solid #2b2d3c !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:first-child {
  color: #f4ead8 !important;
  font-size: 24px !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:first-child::before {
  content: "房间详情" !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:first-child {
  font-size: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:first-child::before {
  font-size: 24px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-btn span {
  height: 40px !important;
  border: 1px solid rgba(236, 216, 184, 0.34) !important;
  border-radius: 6px !important;
  color: #ecd8b8 !important;
  background: #252837 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  margin: 18px 0 22px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box .roombox-warp ul {
  min-height: 112px !important;
  padding: 16px 18px !important;
  background:
    radial-gradient(ellipse at 50% 100%, rgba(236, 216, 184, 0.09), transparent 58%),
    #20222f !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roombox-num .roombox-img {
  width: 82px !important;
  height: 74px !important;
  border-radius: 7px !important;
  background:
    radial-gradient(circle at 50% 45%, rgba(236, 216, 184, 0.12), transparent 60%),
    #252837 !important;
}

body:has(.pk-battle-room) .pk-battle-room #room-li::before {
  border-color: #ecd8b8 !important;
  box-shadow: 0 0 24px rgba(236, 216, 184, 0.2) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  gap: 12px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 540px !important;
  border: 1px solid rgba(67, 73, 96, 0.72) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 18%, rgba(236, 216, 184, 0.07), transparent 46%),
    #20222f !important;
  box-shadow: none !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 148px !important;
  line-height: 148px !important;
  background:
    linear-gradient(90deg, transparent 49.75%, rgba(236, 216, 184, 0.38) 49.75% 50.25%, transparent 50.25%),
    radial-gradient(ellipse at 50% 50%, rgba(255, 138, 31, 0.14), transparent 58%),
    #191b26 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 148px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  width: 342px !important;
  top: 214px !important;
  right: 24px !important;
  height: calc(100vh - 238px) !important;
  border: 1px solid rgba(67, 73, 96, 0.72) !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: 0 22px 52px rgba(0, 0, 0, 0.28) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-name {
  color: #f4ead8 !important;
  background: #252837 !important;
  border-bottom: 1px solid #2b2d3c !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    padding: 18px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    height: auto !important;
    margin: 18px 14px 0 !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle room state polish: keep after all room overrides. */
body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp {
  overflow: visible !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  position: relative !important;
  overflow: hidden !important;
  border-radius: 13px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp::before {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  pointer-events: none !important;
  background:
    radial-gradient(circle at 50% 20%, rgba(255, 154, 25, 0.16), transparent 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.025), transparent 34%) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1 {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img {
  width: auto !important;
  min-width: 176px !important;
  height: 56px !important;
  position: static !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 3 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img .el-button {
  min-width: 176px !important;
  height: 48px !important;
  padding: 0 28px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: transparent !important;
  font-size: 0 !important;
  background:
    linear-gradient(180deg, rgba(255, 233, 181, 0.14), transparent),
    linear-gradient(180deg, #ff9a18, #f26900) !important;
  border: 1px solid rgba(255, 217, 150, 0.42) !important;
  border-radius: 7px !important;
  box-shadow:
    0 0 0 1px rgba(255, 117, 0, 0.28),
    0 16px 30px rgba(242, 105, 0, 0.34) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img .el-button::after {
  content: "\52a0\5165\5bf9\6218" !important;
  color: #fff7df !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
  letter-spacing: 0.5px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img .el-button.is-disabled {
  opacity: 0.72 !important;
  filter: grayscale(0.25) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  min-height: 78px !important;
  padding: 12px 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 span {
  position: relative !important;
  color: transparent !important;
  font-size: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 span::before {
  content: "" !important;
  display: block !important;
  width: 42px !important;
  height: 42px !important;
  margin: 0 auto 8px !important;
  border-radius: 50% !important;
  background:
    radial-gradient(circle, rgba(255, 154, 25, 0.34), transparent 58%),
    linear-gradient(180deg, #2b2f40, #1d202b) !important;
  border: 1px dashed rgba(255, 217, 150, 0.34) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 span::after {
  content: "\7b49\5f85\73a9\5bb6" !important;
  color: #aeb7c8 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-name::after {
  content: "\5305\542b\4ee5\4e0b\5956\52b1" !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-title::after {
  content: "\8be6\60c5" !important;
}
</style>

<style lang="less">
/* 2026-07-03 battle room final overrides: must stay after legacy style blocks. */
body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: min(1364px, calc(100vw - 236px)) !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 26px 372px 86px 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint,
body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  width: 100% !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  width: 100% !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 {
  width: auto !important;
  min-width: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  width: 100% !important;
  min-height: 604px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 176px !important;
  line-height: 176px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 176px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  width: 340px !important;
  right: 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  width: 100% !important;
  min-height: 96px !important;
  display: grid !important;
  grid-template-columns: 104px minmax(0, 1fr) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  height: 94px !important;
  min-height: 94px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 96px !important;
  max-height: 82px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  height: 94px !important;
  padding: 0 12px !important;
  justify-content: flex-start !important;
  text-align: left !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="less">
/* Final cascade for the target room density pass. */
html {
body:has(.pk-battle-room) .pk-battle-room {
  position: relative !important;
  overflow: visible !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: 100% !important;
  max-width: 1540px !important;
  margin: 0 auto !important;
  padding: 26px 382px 86px 28px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  position: absolute !important;
  top: 26px !important;
  right: max(28px, calc((100% - 1540px) / 2 + 28px)) !important;
  width: 336px !important;
  height: auto !important;
  max-height: 720px !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-list {
  max-height: 636px !important;
  overflow-y: auto !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 148px !important;
  display: block !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  width: 100% !important;
  height: 104px !important;
  min-height: 104px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 126px !important;
  max-height: 92px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  width: 100% !important;
  height: 42px !important;
  padding: 0 8px !important;
  justify-content: center !important;
  text-align: center !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 520px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 152px !important;
  line-height: 152px !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    max-height: none !important;
    margin: 18px 14px 0 !important;
  }
}
}
</style>

<style lang="less">
/* 2026-07-03 target room density pass: keep this block last. */
body:has(.pk-battle-room) .pk-battle-room {
  position: relative !important;
  min-height: calc(100vh - 197px) !important;
  overflow: visible !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: 100% !important;
  max-width: 1540px !important;
  margin: 0 auto !important;
  padding: 26px 382px 86px 28px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  position: absolute !important;
  top: 26px !important;
  right: max(28px, calc((100% - 1540px) / 2 + 28px)) !important;
  width: 336px !important;
  height: auto !important;
  max-height: 720px !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-list {
  max-height: 636px !important;
  overflow-y: auto !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 148px !important;
  display: block !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  width: 100% !important;
  height: 104px !important;
  min-height: 104px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 126px !important;
  max-height: 92px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  width: 100% !important;
  height: 42px !important;
  padding: 0 8px !important;
  justify-content: center !important;
  text-align: center !important;
  overflow: hidden !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 520px !important;
  padding: 14px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 152px !important;
  line-height: 152px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 152px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-ul {
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr)) !important;
  gap: 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp {
  min-height: 158px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img {
  height: 104px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img img {
  max-height: 92px !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    max-height: none !important;
    margin: 18px 14px 0 !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right-list {
    max-height: none !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle room layout fix: align with shared shell and widen fight columns. */
body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: min(1364px, calc(100vw - 236px)) !important;
  margin: 0 !important;
  padding: 26px 372px 86px 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint,
body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  width: 100% !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  width: 100% !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 {
  min-width: 0 !important;
  width: auto !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  width: 100% !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  grid-template-columns: 1fr !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 96px !important;
  display: grid !important;
  grid-template-columns: 104px minmax(0, 1fr) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  height: 94px !important;
  min-height: 94px !important;
  border-radius: 8px 0 0 8px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 96px !important;
  max-height: 82px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  height: 94px !important;
  padding: 0 12px !important;
  justify-content: flex-start !important;
  text-align: left !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle room parity pass: target-like room stage without touching backend data. */
body:has(.pk-battle-room) .pk-battle-room {
  min-height: calc(100vh - 118px) !important;
  padding: 0 !important;
  color: #f5f7ff !important;
  background:
    radial-gradient(ellipse at 48% 0%, rgba(255, 194, 92, 0.12), transparent 34%),
    radial-gradient(ellipse at 50% 26%, rgba(35, 226, 246, 0.08), transparent 36%),
    linear-gradient(180deg, #202231 0%, #191b27 56%, #171923 100%) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: min(1518px, calc(100vw - 276px)) !important;
  max-width: none !important;
  min-height: calc(100vh - 118px) !important;
  margin: 0 0 0 236px !important;
  padding: 26px 372px 86px 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint {
  height: 58px !important;
  min-height: 58px !important;
  padding: 0 0 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-bottom: 1px solid rgba(111, 121, 151, 0.28) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span {
  font-size: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:first-child::after {
  content: "盲盒对战" !important;
  color: #f5f7ff !important;
  font-size: 28px !important;
  line-height: 34px !important;
  font-weight: 1000 !important;
  text-shadow: 0 0 22px rgba(255, 194, 92, 0.18) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:nth-child(2)::after {
  content: "/" !important;
  color: #7d8496 !important;
  font-size: 17px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-num span:nth-child(3)::after {
  content: "房间详情" !important;
  color: #aab3c7 !important;
  font-size: 15px !important;
  font-weight: 800 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-btn {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-btn span {
  min-width: 104px !important;
  height: 42px !important;
  padding: 0 16px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #d9e0ef !important;
  background: rgba(42, 45, 60, 0.86) !important;
  border: 1px solid rgba(111, 121, 151, 0.44) !important;
  border-radius: 6px !important;
  font-size: 0 !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-btn span:first-child::after {
  content: "对战规则" !important;
  font-size: 14px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomleft-btn span:nth-child(2)::after {
  content: "对战历史" !important;
  font-size: 14px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  margin: 24px 0 26px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box .roombox-warp ul {
  min-height: 154px !important;
  padding: 22px 28px !important;
  display: flex !important;
  align-items: center !important;
  gap: 18px !important;
  overflow-x: auto !important;
  background:
    linear-gradient(90deg, rgba(255, 194, 92, 0.08), transparent 22%, transparent 78%, rgba(35, 226, 246, 0.06)),
    linear-gradient(180deg, rgba(43, 46, 62, 0.98), rgba(32, 34, 48, 0.98)) !important;
  border: 1px solid rgba(111, 121, 151, 0.26) !important;
  border-bottom-color: rgba(255, 122, 0, 0.72) !important;
  border-radius: 12px !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 22px 48px rgba(0, 0, 0, 0.2) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-box .roombox-warp ul li {
  width: 116px !important;
  height: 108px !important;
  flex: 0 0 116px !important;
  position: relative !important;
  border-radius: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roombox-num .roombox-img {
  width: 116px !important;
  height: 104px !important;
  display: grid !important;
  place-items: center !important;
  background:
    radial-gradient(circle at 50% 45%, rgba(255, 194, 92, 0.18), rgba(135, 77, 255, 0.14) 34%, transparent 66%),
    #292c3b !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  border-radius: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roombox-num .roombox-img img {
  width: 112px !important;
  height: 100px !important;
  object-fit: contain !important;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.42)) !important;
}

body:has(.pk-battle-room) .pk-battle-room #room-li::before {
  content: "" !important;
  position: absolute !important;
  inset: -4px !important;
  border: 1px solid rgba(255, 194, 92, 0.92) !important;
  border-radius: 13px !important;
  box-shadow:
    0 0 32px rgba(255, 194, 92, 0.24),
    inset 0 0 0 1px rgba(255, 244, 208, 0.16) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp {
  position: relative !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)) !important;
  gap: 16px !important;
  padding: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 {
  width: auto !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 604px !important;
  padding: 14px !important;
  border: 1px solid rgba(111, 121, 151, 0.28) !important;
  border-bottom-color: rgba(255, 122, 0, 0.72) !important;
  border-radius: 12px !important;
  background:
    radial-gradient(circle at 50% 9%, rgba(255, 194, 92, 0.1), transparent 28%),
    linear-gradient(180deg, #292c3b 0%, #202230 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 18px 38px rgba(0, 0, 0, 0.18) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 176px !important;
  line-height: 176px !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  background:
    linear-gradient(90deg, transparent 49.7%, rgba(244, 222, 181, 0.42) 49.7% 50.3%, transparent 50.3%),
    radial-gradient(circle at 50% 50%, rgba(255, 194, 92, 0.15), transparent 58%),
    #191b26 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 176px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img .el-button {
  min-width: 152px !important;
  height: 44px !important;
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff9a19, #f26900) !important;
  border: 0 !important;
  border-radius: 6px !important;
  box-shadow: 0 14px 26px rgba(242, 105, 0, 0.28) !important;
  font-size: 0 !important;
  font-weight: 1000 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room1-img .el-button::after {
  content: "加入对战" !important;
  font-size: 15px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 {
  height: 76px !important;
  padding: 16px 0 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 span {
  color: transparent !important;
  font-size: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2 span::after {
  content: "等待玩家" !important;
  color: #9ea8bd !important;
  font-size: 14px !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2-tou,
body:has(.pk-battle-room) .pk-battle-room .room2-tou img {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50% !important;
}

body:has(.pk-battle-room) .pk-battle-room .room2-name {
  max-width: 100% !important;
  margin-top: 8px !important;
  color: #f4f7ff !important;
  font-size: 14px !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-list {
  margin-top: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-title {
  height: 34px !important;
  justify-content: center !important;
  color: #ffc34d !important;
  font-size: 18px !important;
  font-weight: 1000 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-ul {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(116px, 1fr)) !important;
  gap: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp {
  min-height: 176px !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  border-radius: 8px !important;
  background: #282b39 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img {
  height: 112px !important;
  background:
    radial-gradient(circle at 50% 45%, rgba(135, 77, 255, 0.2), transparent 58%),
    #202230 !important;
}

body:has(.pk-battle-room) .pk-battle-room .win-warp .img img {
  max-width: 104px !important;
  max-height: 96px !important;
  object-fit: contain !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  width: 340px !important;
  height: calc(100vh - 236px) !important;
  position: fixed !important;
  top: 212px !important;
  right: 20px !important;
  z-index: 4 !important;
  border: 1px solid rgba(111, 121, 151, 0.28) !important;
  border-bottom-color: rgba(255, 122, 0, 0.58) !important;
  border-radius: 12px !important;
  background: #202230 !important;
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.3) !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-name {
  min-height: 64px !important;
  padding: 15px 16px !important;
  color: transparent !important;
  font-size: 0 !important;
  background:
    radial-gradient(circle at 82% 0, rgba(255, 194, 92, 0.14), transparent 46%),
    #242736 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-name span {
  display: block !important;
  color: #f5f7ff !important;
  font-size: 15px !important;
  line-height: 20px !important;
  font-weight: 1000 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right-name::after {
  content: "包含以下奖励" !important;
  display: block !important;
  margin-top: 3px !important;
  color: #8f98ab !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-weight: 900 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-title {
  height: 42px !important;
  padding: 0 16px !important;
  display: flex !important;
  align-items: center !important;
  color: transparent !important;
  font-size: 0 !important;
  background: #191b26 !important;
  border-top: 1px solid rgba(111, 121, 151, 0.2) !important;
  border-bottom: 1px solid rgba(111, 121, 151, 0.2) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-title::after {
  content: "详情" !important;
  color: #f5f7ff !important;
  font-size: 14px !important;
  font-weight: 1000 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist {
  padding: 12px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  min-height: 154px !important;
  border: 1px solid rgba(111, 121, 151, 0.24) !important;
  border-radius: 9px !important;
  background: #282b39 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  height: 104px !important;
  min-height: 104px !important;
  display: grid !important;
  place-items: center !important;
  background:
    radial-gradient(circle at 50% 45%, rgba(135, 77, 255, 0.2), transparent 58%),
    #202230 !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 128px !important;
  max-height: 92px !important;
  object-fit: contain !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  height: 46px !important;
  padding: 0 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #e8edf8 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  font-weight: 900 !important;
  text-align: center !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    margin: 0 !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    height: auto !important;
    margin: 18px 14px 0 !important;
  }
}
</style>

<style lang="less">
.pk-battle-room {
  background:
    radial-gradient(circle at 42% 14%, rgba(112, 74, 255, 0.22), transparent 30%),
    radial-gradient(circle at 78% 28%, rgba(242, 105, 0, 0.14), transparent 30%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%) !important;
}

.pk-battle-room .room-left {
  max-width: 1540px !important;
  margin: 0 auto !important;
  padding: 28px 366px 72px 28px !important;
}

.pk-battle-room .room-left-hint {
  min-height: 58px !important;
  padding-bottom: 18px !important;
  border-bottom-color: rgba(236, 216, 184, 0.18) !important;
}

.pk-battle-room .roomleft-num span:first-child {
  color: #f7efe0 !important;
  font-size: 26px !important;
  text-shadow: 0 0 18px rgba(255, 214, 128, 0.22) !important;
}

.pk-battle-room .roomleft-btn span {
  min-width: 86px !important;
  height: 40px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(39, 42, 57, 0.82) !important;
}

.pk-battle-room .room-left-box {
  margin: 22px 0 24px !important;
}

.pk-battle-room .room-left-box .roombox-warp ul {
  min-height: 122px !important;
  padding: 20px 22px !important;
  background:
    radial-gradient(ellipse at 48% 52%, rgba(255, 132, 31, 0.14), transparent 54%),
    linear-gradient(180deg, #252837, #20222f) !important;
  border-color: rgba(255, 132, 31, 0.22) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 224, 170, 0.06),
    0 18px 42px rgba(0, 0, 0, 0.22) !important;
}

.pk-battle-room .room-left-box .roombox-warp ul li {
  width: 92px !important;
}

.pk-battle-room .roombox-num .roombox-img {
  width: 88px !important;
  height: 78px !important;
  background:
    radial-gradient(circle at 50% 44%, rgba(255, 132, 31, 0.12), rgba(129, 73, 255, 0.18), transparent 66%),
    #2a2d3b !important;
}

.pk-battle-room .roombox-num .roombox-img img {
  width: 82px !important;
  height: 70px !important;
}

.pk-battle-room #room-li::before {
  border-color: rgba(255, 132, 31, 0.94) !important;
  box-shadow:
    0 0 32px rgba(255, 132, 31, 0.34),
    inset 0 0 0 1px rgba(255, 221, 160, 0.16) !important;
}

.pk-battle-room .room-left-people .roompe-warp .ul1 {
  gap: 18px !important;
}

.pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  min-height: 590px !important;
  padding: 16px !important;
  border-color: rgba(111, 121, 151, 0.28) !important;
  background:
    radial-gradient(circle at 50% 20%, rgba(118, 83, 255, 0.18), transparent 44%),
    linear-gradient(180deg, #282b3a, #20222f) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 20px 42px rgba(0, 0, 0, 0.18) !important;
}

.pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
.pk-battle-room .room-left-people .pool {
  height: 148px !important;
  line-height: 148px !important;
  background:
    linear-gradient(90deg, transparent 49.75%, rgba(244, 222, 181, 0.35) 49.75% 50.25%, transparent 50.25%),
    radial-gradient(circle at 50% 50%, rgba(255, 132, 31, 0.18), transparent 58%),
    #191b26 !important;
  box-shadow: inset 0 0 0 1px rgba(111, 121, 151, 0.16) !important;
}

.pk-battle-room .room-left-people .pool-img {
  height: 148px !important;
}

.pk-battle-room .room-left-people .pool-img img {
  height: 138px !important;
}

.pk-battle-room .win-warp {
  border-color: rgba(111, 121, 151, 0.26) !important;
}

.pk-battle-room .win-warp .img {
  height: 128px !important;
}

.pk-battle-room .win-warp .img img {
  max-height: 112px !important;
}

.pk-battle-room .room-right {
  width: 338px !important;
  top: 212px !important;
  right: calc((100vw - min(1540px, calc(100vw - 56px))) / 2 + 28px) !important;
  height: calc(100vh - 236px) !important;
  border-color: rgba(255, 132, 31, 0.2) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 224, 170, 0.05),
    0 22px 52px rgba(0, 0, 0, 0.28) !important;
}

.pk-battle-room .room-right-name {
  background:
    radial-gradient(circle at 80% 0, rgba(255, 132, 31, 0.12), transparent 46%),
    #20222f !important;
}

.pk-battle-room .roomlist-img {
  min-height: 118px !important;
}

@media screen and (max-width: 1180px) {
  .pk-battle-room .room-left {
    padding: 20px 14px 72px !important;
  }

  .pk-battle-room .room-right {
    position: static !important;
    width: auto !important;
    height: auto !important;
    margin: 18px 14px 0 !important;
  }
}
</style>

<style lang="less">
/* 2026-07-03 battle room final overrides: must stay after legacy style blocks. */
body:has(.pk-battle-room) .pk-battle-room .room-left {
  width: min(1364px, calc(100vw - 236px)) !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 26px 372px 86px 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-hint,
body:has(.pk-battle-room) .pk-battle-room .room-left-box {
  width: 100% !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
  width: 100% !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 {
  width: auto !important;
  min-width: 0 !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp {
  width: 100% !important;
  min-height: 604px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 .li1 .room-warp .room1,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool {
  height: 176px !important;
  line-height: 176px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img,
body:has(.pk-battle-room) .pk-battle-room .room-left-people .pool-img img {
  height: 176px !important;
}

body:has(.pk-battle-room) .pk-battle-room .room-right {
  width: 340px !important;
  right: 20px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist ul {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 10px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-warp {
  width: 100% !important;
  min-height: 96px !important;
  display: grid !important;
  grid-template-columns: 104px minmax(0, 1fr) !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img {
  height: 94px !important;
  min-height: 94px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-img img {
  max-width: 96px !important;
  max-height: 82px !important;
}

body:has(.pk-battle-room) .pk-battle-room .roomlist-name {
  height: 94px !important;
  padding: 0 12px !important;
  justify-content: flex-start !important;
  text-align: left !important;
}

@media screen and (max-width: 1180px) {
  body:has(.pk-battle-room) .pk-battle-room .room-left {
    width: auto !important;
    padding: 20px 14px 72px !important;
  }

  body:has(.pk-battle-room) .pk-battle-room .room-left-people .roompe-warp .ul1 {
    grid-template-columns: 1fr !important;
  }
}
</style>
